import { socialAuths, loading } from '../state'
import { authService } from '../../../services/auth/auth-service'

/**
 * Check authentication status for social platforms
 * @param {string} assetId - Asset ID
 */
export const checkAuth = async (assetId) => {
  if (!assetId) {
    console.error('Missing assetId in checkAuth')
    loading.value = false
    return
  }
  
  try {
    loading.value = true
    socialAuths.value = await authService.checkSocialAuth(assetId)
  } catch (error) {
    console.error('Error in checkAuth composable:', error)
    socialAuths.value = {}
  } finally {
    loading.value = false
  }
}
